module.exports = __webpack_public_path__ + "img/ios-app.dc2fd1db.png";